/**
 * Type guard that checks if a given route object is a PageRouteObject.
 *
 * @param {GlobalAppRouteObject} routeObject - The route object to check.
 * @returns {routeObject is PageRouteObject} True if the route object is a PageRouteObject.
 */
export function isPageRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'page';
}
/**
 * Type guard that checks if a given route object is a TabRouteObject.
 *
 * @param {TabRouteObject | OtherRouteObject<TabRouteObject>} routeObject - The route object to check.
 * @returns {routeObject is TabRouteObject} True if the route object is a TabRouteObject.
 */
export function isTabRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'tab';
}
/**
 * Type guard that checks if a given GlobalAppRouteObject is a TabsRouteObject.
 *
 * @param {GlobalAppRouteObject} routeObject - The route object to check.
 * @returns {routeObject is TabRouteObject} True if the route object is a TabsRouteObject.
 */
export function isTabsRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'tabs';
}
